import {useEffect, useState} from 'react';
import {SFuncModal} from 'shj-components';
import {Col, Form, Input, InputNumber, message, Row, Select, Skeleton,} from 'antd';
import {useRequest} from "ahooks";
import {qualityMoneyAccountAddAccountDetail} from "@/services/qualityMoneyAccount.ts";

const {Option} = Select;

export function addOrEditFn({fn, ...rest}) {
    const onClose = () => {
        dialog.destroy();
    };
    const dialog = SFuncModal({
        title: `${rest?.id ? '编辑' : '新增'}`,
        width: 600,
        vanish: true,
        content: <ModalAddOrEditDom onClose={onClose} fn={fn} {...rest} />,
    });

    return dialog;
}

const TextArea = Input.TextArea;

const ModalAddOrEditDom = ({onClose, fn, ...rest}) => {
    const [form] = Form.useForm();
    const [amountList, setAmountList] = useState([
        {
            minAmount: 0,
        },
    ]);
    const [loading, setLoading] = useState(false);
    const {setFieldsValue} = form;

    let {loading: submitLoading, runAsync} = useRequest(qualityMoneyAccountAddAccountDetail, {manual: true});

    useEffect(() => {
        console.log(rest);
        if (rest?.id) {
            getDetail(rest?.id);
        } else {
            setFieldsValue({
                configDetails: amountList,
            });
        }
        return () => {
        };
    }, []);

    //根据ID获取详情
    const getDetail = (id) => {
        setLoading(true);
    };
    // 提交
    const onFinish = () => {
        form.validateFields().then((values: any) => {
            console.log(values);
            let obj = {
                syncStatus: false,
                accountId: rest?.accountId,
                status: 'queRecorded',
                ...values,
            };
            console.log(obj);

            runAsync({data: obj}).then(() => {
                message.success('操作成功')
                onClose();
                rest.okCall?.()
            })
        })

    };

    const closeModal = () => {
        onClose();
    };

    const reqMeg = '不能为空';
    return (
        <div>
            {loading ? (
                <Skeleton active/>
            ) : (
                <SFuncModal.Content
                    onCancel={closeModal}
                    onOk={onFinish}
                    confirmLoading={submitLoading}>
                    <Form form={form} layout="vertical">
                        <Form.Item label="类型" name="changeType"
                                   rules={[{required: true, message: reqMeg}]}>
                            <Select
                                showSearch
                                allowClear={true}
                                filterOption={(input: any, option: any) => {
                                    return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                }}
                                optionFilterProp="children"
                            >
                                {rest.quaChangeTypeEnum.map((item, index) => (
                                    <Option key={index} value={item.key}>
                                        {item.description}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Row>
                            <Col span={24}>
                                <Form.Item label="金额" name="amount"
                                           rules={[{required: true, message: reqMeg}]}>
                                    <InputNumber precision={2} min={1} max={999999.99} style={{width: '100%'}}/>
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    label="变更原因"
                                    name="changeReason"
                                    rules={[{required: true, message: reqMeg}]}
                                >
                                    <Select
                                        showSearch
                                        allowClear={true}
                                        filterOption={(input: any, option: any) => {
                                            return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                        }}
                                        optionFilterProp="children"
                                    >
                                        {rest.quaChangeReasonEnum.map((item, index) => (
                                            <Option key={index} value={item.key}>
                                                {item.description}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    label="变更说明"
                                    name="changeDescribe"
                                    rules={[{required: true, message: reqMeg}]}

                                >
                                    <TextArea rows={2}  autoSize={true} maxLength={200}/>
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    label="来源单号"
                                    name="sourceNumber"
                                    rules={[{required: false, message: reqMeg}]}

                                >
                                    <TextArea rows={2} autoSize={true} maxLength={50}/>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </SFuncModal.Content>
            )}
        </div>
    );
};
